
import React from 'react';
import { AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, Radio } from "@/components/ui/radio-group";
import { AlertCircle } from "lucide-react";
import { DeletionReasons } from "./deletionReasons";

interface DeleteAccountDialogProps {
  isDeleting: boolean;
  feedback: string;
  setFeedback: (value: string) => void;
  reason: string;
  setReason: (value: string) => void;
  handleDeleteAccount: () => Promise<void>;
}

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
  isDeleting,
  feedback,
  setFeedback,
  reason,
  setReason,
  handleDeleteAccount
}) => {
  return (
    <AlertDialogContent className="max-w-md w-[95vw] sm:w-full overflow-y-auto max-h-[90vh]">
      <AlertDialogHeader>
        <div className="flex items-center gap-2 text-destructive mb-2">
          <AlertCircle className="h-5 w-5" />
          <AlertDialogTitle>Delete your account?</AlertDialogTitle>
        </div>
        <AlertDialogDescription>
          This action cannot be undone. It will permanently delete your account
          and remove all your data from our servers.
        </AlertDialogDescription>
      </AlertDialogHeader>
      
      <div className="space-y-4 my-4">
        <h4 className="font-medium text-sm">Why are you leaving? (Optional)</h4>
        <RadioGroup value={reason} onValueChange={setReason} className="space-y-3">
          {DeletionReasons.map((item) => (
            <div key={item.value} className="flex items-center space-x-2">
              <Radio id={item.value} value={item.value} />
              <label htmlFor={item.value} className="text-sm">
                {item.label}
              </label>
            </div>
          ))}
        </RadioGroup>
        
        <div>
          <label htmlFor="feedback" className="text-sm font-medium block mb-1">
            Share more details (Optional)
          </label>
          <Textarea
            id="feedback"
            placeholder="Tell us what we could do better..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            className="min-h-[100px]"
          />
        </div>
      </div>
      
      <AlertDialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
        <AlertDialogCancel className="mb-2 sm:mb-0">Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={handleDeleteAccount}
          disabled={isDeleting}
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
        >
          {isDeleting ? "Deleting..." : "Yes, delete my account"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
};

export default DeleteAccountDialog;
